import { render, staticRenderFns } from "./category-popup.vue?vue&type=template&id=5f9b5b1f&scoped=true&"
import script from "./category-popup.vue?vue&type=script&lang=js&"
export * from "./category-popup.vue?vue&type=script&lang=js&"
import style0 from "./category-popup.vue?vue&type=style&index=0&id=5f9b5b1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9b5b1f",
  null
  
)

export default component.exports